var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","fill":"none","fillRule":"evenodd","strokeLinecap":"square"},React.createElement("path",{"d":"M.5 0l5 5M10.5 0l-5 5"})));
}

Chevron.defaultProps = {"width":"11","height":"5"};

module.exports = Chevron;

Chevron.default = Chevron;
